import { Gender } from "./Gender";
import { MessageToUser } from "./MessageToUser";
import { OnboardingState } from "./OnboardingState";

export interface User {
  identifier: string;
  fullName: string;
  email: string;
  profilePhotoURL?: string;
  gender: Gender;
  didPassTutorialCards: boolean;
  didFinishOnboarding: boolean;
  lastOpenedVersionOfApp?: string;
  invitationCode?: string;
  messageToUser?: MessageToUser;
  isPlayingAlone: boolean;
  /** Has seen the one-time "extra swipes wait for your daily cards" coach mark. */
  didSeeExtraSwipesQueuedExplainer?: boolean;
  selectedCharacter?: string | null;
  validPartnershipsIdentifiers: string[];
  requestingPartnersIdentifiers: Record<string, number>;
  lastPartnershipsVisits: Record<string, number>;
  partnershipsLastMatchesScreenVisit: Record<string, number>;
  partnershipsDeckTopCardIdentifiers: Record<string, string>;
  partnershipsNumberOfCardsInDeckLeft: Record<string, number>;
}

export class UserHelper {
  static isOnboardedCorrectly(user: User): OnboardingState | null {
    if (!user.fullName || user.fullName.trim().length === 0) {
      return OnboardingState.Name;
    }
    return null;
  }

  static createEmptyUser(identifier: string, email: string): User {
    return {
      identifier,
      fullName: "",
      email,
      gender: Gender.Unknown,
      didPassTutorialCards: true,
      didFinishOnboarding: true,
      isPlayingAlone: false,
      selectedCharacter: null,
      validPartnershipsIdentifiers: [],
      requestingPartnersIdentifiers: {},
      lastPartnershipsVisits: {},
      partnershipsLastMatchesScreenVisit: {},
      partnershipsDeckTopCardIdentifiers: {},
      partnershipsNumberOfCardsInDeckLeft: {},
    };
  }
}
